import React, {useMemo} from 'react'
import {Button} from "../../../ui-components";
import {InfoTooltipTrigger, PanelFooter} from "../../../shared";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import {changeCustomerErCallStatus} from "../../requests/er-thunk";
import HospitalizationBrigadeInfo from "./HospitalizationBrigadeInfo";
import CustomerDpInfo from "../CustomerDpInfo";
import BrigadeInfo from "../../brigade/brigadeInfo";
import CustomerActionsTooltip from "./customerActionsTooltip";
import DpDcActionsPopover from "./DpDcActionsPopover";
import PayInfoDp from "../../sentry/DpComponents/PayInfoDp";


const SentryStart = () => {
  const {er_call, request} = useAppSelector(state => state.requests)
  const dispatch = useAppDispatch()
  const selectedRequestBrigade = useMemo(() => {
    if (request) {
      return request?.requestedBrigades?.filter((b) => b.request_uuid === request?.uuid)
    }
  }, [request])
  return (
    <div id='on-way-request' className={`request-info-container ${er_call.status < 13 || er_call.status === 21 ? 'pb-80' : ''}`}>
      <PayInfoDp/>
      <HospitalizationBrigadeInfo/>
      {request && request.type ===3 && <CustomerDpInfo/>}
      {request && request?.requestedBrigades && selectedRequestBrigade.map((item) => {
        return <BrigadeInfo br={item}/>
      })}
      {er_call.status < 13 &&
        <>
          <PanelFooter className='footer'>
            <Button type='contained' fullWidth onClick={() => dispatch(changeCustomerErCallStatus(23))}>Начать дежурство</Button>
            <InfoTooltipTrigger dataFor={'actions-menu-customer'} className='ml-15'/>
          </PanelFooter>
          {er_call && er_call.status > 1 &&
            // @ts-ignore
            <CustomerActionsTooltip isDp id='actions-menu-customer' offsetLeft={150} offsetTop={-20}/>}
        </>}
      {er_call.status === 21 &&
        <PanelFooter>
          <Button type='contained' onClick={() => dispatch(changeCustomerErCallStatus(23))} fullWidth>Начать дежурство</Button>
        </PanelFooter>
      }
      <DpDcActionsPopover/>
    </div>
  )
}

export default SentryStart
